import { purchasedGoodsRoutes } from '@app/purchased-goods/purchased-goods-routes';
import { Button } from '@shared/components/ui/button';
import { generatePath, Link, useLocation } from 'react-router-dom';
import FoodPreviewSheet from './food-preview-sheet';

export default function CCFFoodTableToolbar() {
  const location = useLocation();

  return (
    <div className="flex items-center gap-2">
      <Link
        to={
          generatePath(purchasedGoodsRoutes.PURCHASED_GOODS_IMPORTS_LIST) +
          `?activityType=food`
        }
        state={{ from: location.pathname, search: location.search }}
      >
        <Button size="sm" variant="ghost">
          Manage imports
        </Button>
      </Link>
      <FoodPreviewSheet />
      <Link
        to={generatePath(purchasedGoodsRoutes.PURCHASED_GOODS_IMPORT)}
        state={{ from: location.pathname, search: location.search }}
      >
        <Button size="sm">Add data</Button>
      </Link>
    </div>
  );
}
